import appLogo from "assets/images/jobber_logo.svg";
import AppFrame from "components/AppFrame";
import JobberCallback from "pages/JobberCallback";
import InstagramCallback from "pages/InstagramCallback";
import Error from "pages/Error";
import { JobberInstagramStep1, JobberInstagramStep2 } from "pages/Jobber-Instagram";
import {
    Route,
    Routes as ReactRouterRoutes,
} from "react-router-dom";

const Routes = () => {
    return (
        <ReactRouterRoutes>
            <Route element={<AppFrame logo={appLogo} />}>
                <Route path="jobber-instagram-step1" element={<JobberInstagramStep1 />} />
                <Route path="jobber-instagram-step2" element={<JobberInstagramStep2 />} />
                <Route path="error" element={<Error />} />
            </Route>
            <Route path="jobber/callback" element={<JobberCallback />} />
            <Route path="instagram/callback" element={<InstagramCallback />} />
        </ReactRouterRoutes>
    );
};

export default Routes;
